module.exports = __webpack_public_path__ + "assets/img/jinrujaintouxiao.7fa34ed1.svg";